import styled from 'styled-components';

const AboutUsSectionStyle = styled.section`
	--aboutDescMTop: var(--sp6x);

	.about-description {
		margin-top: var(--aboutDescMTop);
		opacity: 0;
		transition: var(--trTime) var(--trTime) ease-in;

		&.active {
			opacity: 1;
		}
	}

	.image-cont {
		margin-top: var(--customDistance2);
		overflow: hidden;
		backface-visibility: hidden;
		isolation: isolate;
		border-radius: var(--sp3x);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--aboutDescMTop: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--aboutDescMTop: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--aboutDescMTop: var(--sp2-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--aboutDescMTop: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default AboutUsSectionStyle;
